import axios from '@/api/axios'

const getKindsSportBySchool = (params) => {
  return axios.get(`/kindsSportForSchool`, {params})
}

const getKindsSport = () => {
  return axios.get(`/kindsSport`)
}

const getKindsSportAll = (params) => {
  if (params) {
    return getKindsSportBySchool(params)
  }

  return getKindsSport()
}

export default {
  getKindsSportBySchool,
  getKindsSportAll,
  getKindsSport,
}
